
import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import ManageItems from './components/ManageItems';
import ManageItemsK from './components/ManageItemsK';
import ManageItems_giv from './components/ManageItems_giv';
import Login from './components/Login';
import Register from './components/Register';
import Login_giv from './components/Login_giv';
import Register_giv from './components/Register_giv';
import Giv from './components/giv';
import { useParams } from 'react-router-dom';
import Procedures from './components/Procedures';
import ItemPresentation from './components/ItemPresentation';
import { AuthProvider, useAuth } from './AuthContext';
import Chat from './components/ChatBot';
import ChatM from './components/ChatBot_r';
import ManagePDFLink from './components/ManagePDFLink';
import ItemForml from './components/ItemFormI';
import ManageUsers from './components/ManageUsers';
import LoginK from './components/LoginK';
import ChatS from './components/ChatBot_k';
import CustomFileInput from './components/inputFile.js';
import EditForm from './components/EditForm'; // Import the EditForm component
import WarehouseManager from './components/WarehouseManager';
import './App.css';
import ItemsList from './components/ItemsList';
import UserOrders from './components/UserOrders';
import OrdersDashboard from './components/OrdersDashboard';
import OrderManager from './components/OrderManager';
import GlobalStyle from './GlobalStyle'; // Import the global styles
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Provider } from 'react-redux'; // ייבוא ה-Provider מ-React Redux
import store from './store'; // ייבוא ה-Store שנוצר ב-Redux


const ProtectedRoute = ({ element: Component, ...rest }) => {
  const { currentUser } = useAuth();
  return currentUser ? <Component {...rest} /> : <Navigate to="/login" />;
};

const AppContent = () => {
  const [showHeader, setShowHeader] = useState(true);
  const { currentUser, isAuthenticated } = useAuth(); // שימוש ב-context מ-AuthProvider

  return (
    <>
      {showHeader && <Header />}
      {/* <Header /> */}
      <Routes>
        <Route
          path="/homeK"
          element={
            <ProtectedRoute element={() => (
              <ItemsList />
            )} />
          }
        />
        <Route
          path="/order-manager"
          element={<ProtectedRoute element={OrderManager} />}
        />
        <Route
          path="/warehouse-manager"
          element={<ProtectedRoute element={WarehouseManager} />}
        />
        <Route
          path="/my-orders"
          element={<ProtectedRoute element={() => <UserOrders user={currentUser} />} />}
        />
        <Route path="/" element={<Chat setShowHeader={setShowHeader} />} />
        <Route path="/pdf" element={<ManagePDFLink />} />
        <Route path="/image" element={<ItemForml />} />
        <Route path="/ManageUsers" element={<ManageUsers />} />
        <Route path="/order_g" element={<OrdersDashboard />} />
        <Route path="/manage-items" element={<ProtectedRoute element={ManageItems} />} />
        <Route path="/login" element={<Login />} />
        <Route path="/loginK" element={<LoginK />} />
        <Route path="/ManageItemsK" element={<ManageItemsK />} />
        <Route path="/register" element={<Register />} />
        <Route path="/manage-items_giv" element={<ProtectedRoute element={ManageItems_giv} />} />
        <Route path="/login_giv" element={<Login_giv />} />
        <Route path="/register_giv" element={<Register_giv />} />
        <Route path="/procedures" element={<Procedures />} />
        <Route path="/search" element={<ItemPresentation />} />
        <Route path="/home" element={<Home />} />
        <Route path="/giv" element={<Giv />} />
        <Route path="/chat_m" element={<ChatM />} />
        <Route path="/chat_s" element={<ChatS />} />
        <Route path="/edit/:id" element={<EditFormWrapper />} /> {/* Add route for editing */}
      </Routes>
    </>
  );
};

const EditFormWrapper = () => {
  const { id } = useParams();
  return <EditForm itemId={id} />;
};

function App() {
  return (
    <>
      <Provider store={store}>
        <AuthProvider> {/* עטיפת האפליקציה ב-AuthProvider */}
          <GlobalStyle />
          <AuthProvider>
            <Router>
              <AppContent />
            </Router>
          </AuthProvider>
        </AuthProvider>
      </Provider>
    </>
  );
}

export default App;
